module.exports = __webpack_public_path__ + "static/img/6218_phase_function_Paper_PointsHejduk_Prediction.a617991.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6218_phase_function_Paper_PointsHejduk_Prediction.png
// module id = kF6W
// module chunks = 0